import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

class AssetsActionDisable extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    asset: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleClick = (e) => {
    e.preventDefault();
    this.props.handleClick(this.props.asset);
  };

  render = () => (
    <Form.Link
      className="btn btn-sm btn-outline-warning w-100 my-1"
      onClick={this.handleClick}
      to={'#'}
    >
      {this.props.t('actions.enable')}
    </Form.Link>
  );
}

export default translate()(AssetsActionDisable);



// WEBPACK FOOTER //
// src/components/assets/actions/AssetsActionsEnable.js